/* global vtvL10n */
import './cookie-banner.js';

import {ie_objectfit_fallback} from './fallbacks.js';

import _ from 'lodash';
import stickybits from 'stickybits';
import {detect as detectBrowser} from 'detect-browser';
// eslint-disable-next-line no-unused-vars
import scrollDepth from 'scroll-depth';
import valuSearch from './valu-search'

export default function () {
    (function (window, document, $) {
        'use strict';

        $('body').addClass('js--browser-detected-' + detectBrowser().name);

        /**
         * Primary navigation toggle
         *
         * - call toggleMobile()
         */
        $('.js-primary-nav-toggle').on('click', function () {
            toggleMobile($(this), $('.js-primary-nav'), 'nav');

            $('html, body').toggleClass('js-main-nav-open');
        });

        // Mobile navigation hacks (this probably needs to be something more solid, maybe fixed in the css?)
        $('.js-primary-nav a, button').on('click', function () {
            if($(this).hasClass('nav--primary__link') || $(this).hasClass('nav--primary__sublink')) {
                return;
            }

            window.scrollTo(0, 0);
        });

        /**
         * Search form toggle
         *
         * - call toggleMobile()
         *
         * Now in the valu search module
         */

        valuSearch();

        /**
         * Language switcher toggle
         *
         * - call toggleMobile()
         */
        $('.js-language-switcher-toggle').on('click', function () {
            toggleMobile($(this), $('.site-lang__select'), 'language');
        });

        /**
         * Toggle mobile header animations
         *
         * - add/remove 'state-active' class to trigger element
         * - add/remove 'state-open' class to target element
         * - add 'aria-expanded' true/false to trigger element
         */

        function toggleMobile($trigger, $target, $type) {
            if ($trigger.length > 0 && $target.length > 0) {
                var container = $('.site-content');

                // Check if something else than target is open and close it
                if ($('.state-open').length && !$target.hasClass('state-open')) {
                    $('.state-open').removeClass('state-open').css('display', 'none');
                    $('.state-active').removeClass('state-active').attr('aria-expanded', false);
                    $('.overlay').remove();
                    $('.speechbubble-arrow').css('display', 'none');
                    $('.language-arrow svg').css('transform', 'rotate(90deg)');
                    $('[class^="js-close-mobile-"]').hide();
                    $('[class^="js-open-mobile-"]').show();
                    container.css('position', 'static');
                }

                // Toggle target open state
                if ($target.hasClass('state-open')) {
                    if ($type == 'search' || $type == 'language') {
                        $target.fadeOut('fast');
                        container.css('position', 'static');
                        if ($type == 'language') {
                            $('.speechbubble-arrow').fadeOut('fast');
                            $('.language-arrow svg').css('transform', 'rotate(90deg)');
                        }
                    } else {
                        $('.js-close-mobile-menu').hide();
                        $('.js-open-mobile-menu').show();
                        $target.hide();
                        $('.nav--primary__item--has-children').removeClass('js-submenu-toggle-mobile--open');
                    }
                    $target.removeClass('state-open');
                    $trigger.removeClass('state-active').attr('aria-expanded', false);
                    $('html, body').css({'overflow': '', 'height': 'auto'});
                } else {
                    if ($type == 'search' || $type == 'language') {
                        $target.fadeIn('fast');
                        if ($type == 'language') {
                            $('.speechbubble-arrow').fadeIn('fast');
                            $('.language-arrow svg').css('transform', 'rotate(270deg)');
                        }
                    } else {
                        $('.js-open-mobile-menu').hide();
                        $('.js-close-mobile-menu').show();
                        $target.show();
                    }
                    container.css('position', 'relative');
                    $target.addClass('state-open');
                    $trigger.addClass('state-active').attr('aria-expanded', true);

                    $('html, body').toggleClass('js-ios-fixes');
                }
            }
        }

        /**
         * Handle sub navigation toggle
         *
         * - call on click
         */
        function subNavHandler() {
            $('.js-submenu-toggle').on('click', function () {
                $(this).siblings('.nav__submenu-wrapper').fadeToggle(0);
                $(this).toggleClass('js-submenu-toggle--open');

                if ($(this).hasClass('js-submenu-toggle--open')) {
                    $(this).attr('aria-expanded', true);
                } else {
                    $(this).attr('aria-expanded', false);
                }

                // Desktop
                if (!$('.state-open').length) {
                    $('.js-submenu-toggle--open').not(this).siblings('.nav__submenu-wrapper').fadeOut(0);
                    $('.js-submenu-toggle--open').not(this).removeClass('js-submenu-toggle--open').attr('aria-expanded', false);
                    $('.nav__submenu-wrapper--2').show();
                }

                // Mobile
                if ($('.state-open').length) {
                    $(this).parent().toggleClass('js-submenu-toggle-mobile--open');
                    $('.nav--primary').scrollTop(0);
                }
            });

            $('.js-submenu-icon-close').on('click', function () {
                $(this).closest('.nav__submenu-wrapper').fadeToggle('fast');
                $('.js-submenu-toggle--open').toggleClass('js-submenu-toggle--open');
            });
        }

        subNavHandler();

        /* Handle open/closed term popup */
        function termPopupHandler() {
            $('.term-popup-link').on('click', function () {
                var term_popup = $('.term-popup[data-term-id="' + $(this).data("term-id") + '"]');

                if (term_popup) {
                    term_popup.fadeIn('fast');
                    $('body').css('overflow-y', 'hidden');
                }
            });

            $('.term-popup__close').on('click', function () {
                var term_popup = $('.term-popup[data-term-id="' + $(this).data("term-id") + '"]');

                if (term_popup) {
                    term_popup.fadeOut('fast');
                    $('body').css('overflow-y', '');
                }
            });
        }

        termPopupHandler();

        /* Check article bottom border depending on selected components */

        function checkArticleBorder() {
            if ($('.article .related-posts--multi').length) {
                $('.article').css('border-bottom', '2rem #edf4f6 solid');
            } else if ($('.article').length) {
                $('.article').css('border-bottom', '2rem white solid');
            }
        }

        checkArticleBorder();

        /* Handle accordion content visibility */

        function accordionHandler() {
            $('.accordion').each(function () {
                var accordion = $(this);
                var accordion_content = accordion.find('.accordion__content');
                var icon = accordion.find('.icon-arrow');

                accordion.on('click', function () {

                    accordion_content.fadeToggle('fast');
                    icon.toggleClass('rotate');

                });
            });
        }

        accordionHandler();

        /* Handle anchor navigation logic */
        function anchor_navigation_handler() {
            $('.js-magnet__anchor').each(function () {
                // Init .js-magnet__anchor
                var header_text = $(this).text();
                var header_id = header_text.toLowerCase().replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');

                $(this).attr('id', header_id);

                // Init .nav--anchor__list
                var list = $('.nav--anchor__list');
                var list_item = jQuery('<li class="nav--anchor__item"> <a class="nav--anchor__link" href="#' + header_id + '">' + header_text + '</a> </li>');

                list_item.appendTo(list);
            });

            // Smooth anchor scroll event
            $('.nav--anchor__link').on('click', function (event) {
                var target = $(this.hash);
                if (target.length) {
                    event.preventDefault();
                    var navHeight = $('.nav--anchor').eq(0).height();
                    $('html, body').animate({
                        scrollTop: target.offset().top - navHeight - 50,  // 50 is a magic number, it used to be 275s ( this just leaves the heading a little bit off from top)
                    }, 500);
                }
            });
        }

        anchor_navigation_handler();

        ie_objectfit_fallback();

    })(window, document, jQuery);

    $(function () {
        // Anchor navigation
        if ($('.nav--anchor').length && $('.js-magnet__anchor').length > 1) {
            var lastScrollTop = 0;
            var delta = 5;
            var navbarHeight = $('.nav--anchor').outerHeight();
            var navbarWidth = 0;
            var navbarMaxWidth = 0;

            // IE sticky
            if (detectBrowser().name == 'ie') {
                stickybits('.nav--anchor');
            }
            // Display anchor nav, but keep hidden until width counted
            $('.nav--anchor').css('display', 'flex').css('visibility', 'hidden');

            // Count desktop anchor nav max width
            navbarWidth = $('.nav--anchor').width();
            navbarMaxWidth = $('.nav--anchor__text').width() +
                $('.nav--anchor__list').width() +
                $('.nav--anchor__icon').width() +
                100; // 100 = padding

            if (navbarMaxWidth > navbarWidth) {
                $('.nav--anchor').addClass('nav--anchor--mobile');
                mobile_anchor_navigation_handler();
            }

            // Show anchor nav
            $('.nav--anchor').css('visibility', 'visible');

            // Show/Hide anchor nav scroll toggle
            $(window).scroll(_.throttle(function () {
                var st = $(this).scrollTop();

                // Make sure that scroll is more than delta
                if (Math.abs(lastScrollTop - st) <= delta) {
                    return;
                }

                // If scrolled down and are past the navbar, add class
                if (st > lastScrollTop && st > navbarHeight) {
                    // Scroll Down
                    if ($('.js-mobile-open').length === 0) {
                        $('.nav--anchor').removeClass('js-nav--anchor-down').addClass('js-nav--anchor-up');
                    }
                    $('.share').removeClass('js-share--down').addClass('js-share--up');
                } else {
                    // Scroll Up
                    if (st + $(window).height() < $(document).height()) {
                        $('.nav--anchor').removeClass('js-nav--anchor-up').addClass('js-nav--anchor-down');
                        $('.share').removeClass('js-share--up').addClass('js-share--down');
                    }
                }
                lastScrollTop = st;
                //HACK: Make sure scrolltop is not changed by forcing it the same to eliminate odd bouncing
                $(this).scrollTop(st);
            }, 250));

            // Desktop/mobile anchor nav resize toggle
            $(window).on('resize', _.throttle(function () {
                if (navbarMaxWidth > $(this).width() || navbarMaxWidth > navbarWidth) {
                    $('.nav--anchor').addClass('nav--anchor--mobile');
                    mobile_anchor_navigation_handler();
                } else {
                    $('.nav--anchor').removeClass('nav--anchor--mobile');
                }
            }, 250));
        }
    });

    /* Add opens in a new tab text to screen readers */

    $("a[target='_blank']").append("<span class='screen-reader-text'> (" + vtvL10n.tab +")</span>");


    /* Handle mobile anchor navigation visibility */

    function mobile_anchor_navigation_handler() {
        $('.nav--anchor--mobile .nav--anchor__text, .nav--anchor--mobile .nav--anchor__item').off().on('click', function () {
            var nav_anchor = $('.nav--anchor--mobile');
            var nav_anchor_content = nav_anchor.find('.nav--anchor__icon, .nav--anchor__list');
            var nav_anchor_svg = nav_anchor.find('svg');

            nav_anchor.toggleClass('js-mobile-open');
            nav_anchor_content.fadeToggle('fast');
            nav_anchor_svg.toggleClass('rotate');
        });
    }

    /* Outside hide clicks */

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.nav__submenu-wrapper, .nav--primary__toggle, .state-open').length) {
            if ($('.nav__submenu-wrapper').is(":visible")) {
                $('.nav__submenu-wrapper').hide();
                $('.js-submenu-toggle--open').attr('aria-expanded', false);
                $('.js-submenu-toggle--open').removeClass('js-submenu-toggle--open');
            }
        }
    });

    $('.js-submenu-toggle').on('click', function (event) {
        event.stopPropagation();
    });

    $(document).on('click', '.notification-order-form-modal__close, .notification-order-form-modal__overlay', function(){
        $('.notification-order-form-modal').toggleClass('notification-order-form-modal--hidden');
        $('.notification-order-form-modal').fadeToggle('fast');
        $('body').css('overflow-y', '');
    })

    $('.notification-subscribe').on('click', function(){
        $('.notification-order-form-modal').toggleClass('notification-order-form-modal--hidden');
        $('.notification-order-form-modal').fadeToggle('fast');
        $('body').css('overflow-y', 'hidden');
        let elems = document.getElementsByName('subscription_type');
        elems[0].focus({preventScroll:true});
    })

    /* Analytics events handling */

    // let links = document.querySelectorAll('.attachment a');
    // for (let i = 0; i < links.length; i++) {
    //     links[i].addEventListener('click', function(e){
    //         e.preventDefault();
    //         // eslint-disable-next-line no-undef
    //         gtag('event', 'document_download', {
    //             'event_category' : 'Download',
    //             'event_label' : this.href,
    //             'value' : 1,
    //             'custom_map' : {'dimension1': this.href}
    //         });
    //         window.location.href = this.href;
    //     });
    // }

    // $.scrollDepth({
    //   eventHandler: function(data) {
    //       if(data.event == "ScrollDistance" && data.eventAction == "Percentage") {
    //           // eslint-disable-next-line no-undef
    //           gtag('event', 'scroll_depth', {
    //               'event_category' : 'Scroll',
    //               'event_label': data.eventLabel,
    //               'value' : data.eventValue,
    //               'custom_map' : {'dimension2': data.eventLabel}
    //           });
    //       }
    //     }
    // });

    /* Crisis announcement */

    var lang = getCookie('pll_language');

    if (getCookie('hideCrisis_' + lang) != 'true') {
        $('.crisis').removeClass('hidecrisis' + lang);
    } else {
        $('.crisis').addClass('hidecrisis' + lang);
    }

    $('.crisis-close').on('click', function() {
        createCookie('hideCrisis_' + lang, 'true');
        $('.crisis').addClass('hidecrisis' + lang);
    });

    function createCookie(name, value) {
        var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    $('.search-form__submit').on('click', function (e) {
        e.preventDefault();
    });

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
        return null;
    }
}


/**
 * Make teaser div clickable
 */

jQuery(function($) {

    $('.article-teaser').on('click', function() {
        var count = $(this).find('a').length;
        var href = $(this).find('a:first').attr('href');
        var target = $(this).find('a:first').attr('target');

        if(href && count == 1) {
            if (target) {
                window.open(href, '_blank');
            } else {
                window.location = href;
            }
            return false;
        }
    });
});


/**
 * Change gform validation message
 */

$('#error .validation_error').html(vtvL10n.validation);

/**
 * Gravity Wiz // Gravity Forms // Disable Submission when Pressing Enter
 * http://gravitywiz.com/disable-submission-when-pressing-enter-for-gravity-forms/
 */
jQuery(document).on( 'keypress', '.gform_wrapper', function (e) {
    var code = e.keyCode || e.which;
    if ( code == 13 && ! jQuery( e.target ).is( 'textarea,input[type="submit"],input[type="button"]' ) ) {
        e.preventDefault();
        return false;
    }
} );



// WEBPACK FOOTER //
// ./js/regular/main.js